export default "__VITE_ASSET__Drww1sqV__"